module.exports = __webpack_public_path__ + "img/left.83b236fe.png";